import type { MenuApiResponse } from 'src/types/json-api'

export type HeaderData = { label: string; items?: { label: string; url: string }[]; url?: string }[]

export const getHeaderData = (res?: MenuApiResponse): HeaderData => {
  return res
    ? res.data
        .filter((item: any) => item.attributes.parent === '')
        .map((item: any) => ({
          label: item.attributes.title,
          items: res.data
            .filter((subItem: any) => subItem.attributes.parent === item.id)
            .map((subItem: any) => ({
              label: subItem.attributes.title,
              url: subItem.attributes.url
            }))
        }))
        .filter((item: any) => item.items?.length)
    : []
}
